module.exports = __webpack_public_path__ + "static/media/si.40983704.svg";